export default function() {
  const matchFields = document.querySelectorAll('[data-validator-match]');

  if (!matchFields.length) {
    return;
  }

  [].forEach.call(matchFields, (function (self) {
    const matchField = document.querySelector(self.dataset['validator-match']);

    if (matchField) {
      matchField.pattern = self.value;
    }
  }));
};
